module.exports = __webpack_public_path__ + "img/footer-bg.823930a5.svg";